import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractItemComponent } from '@df/catalog-ui/abstract-item.component';
import { IPageDataV2 } from '@df/catalog/cms/cms-model.interface';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { LocalPage } from 'projects/app-default/src/app/catalog/page/local/local-page';
import { NBlogCategoryPageType } from '../../page/category-view/cms-blog-page-category-view.component';
import { NBlogPostPageType } from '../../page/post-view/cms-blog-post.namespace';

@Component({
    imports: [DfModuleImageModule, RouterLink, TranslationModule],
    selector: 'cms-blog-content-blog-card',
    templateUrl: './cms-blog-content-blog-card.html',
    styleUrl: './cms-blog-content-blog-card.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogContentBlogCardComponent extends AbstractItemComponent<LocalPage<IPageDataV2<NBlogPostPageType.ITypeData>>> {
    type = ICmsPage.type;
    protected tagCategories: LocalPage<IPageDataV2<NBlogCategoryPageType.ITypeData>>[] = [];

    get typeData() {
        return this.model?.data?.typeData;
    }

    protected override onModelChange(): void {
        this.tagCategories = this.model?.getBlogPostCategories()?.slice(0, 3) || [];
        return super.onModelChange();
    }
}
